import img1 from "./images/illustration/coaches.png";

const Coache=()=>{
    return(
        <>
        <section className="container-fluid">
            <section className="container">
                <section className="row">

                    <div className="col-12">
                        <div className="row py-5">
                        
                        <div className="col-12 col-md-6 mt-5">
                            <h1>Meet Our Best Coaches</h1>
                            <p>Massa vivamus lorem ornare risus diam egestas velit ultrices. Ac in
                                <br /> tempus quam nulla. In viverra vitae viverra mauris eros accumsa
                                n sed <br />vitae suspendisse. Pellentesque orci ipsum gravida nam fames a
                                 rhon.</p>
                                 <div className="row">

                                    <div className="col-12 col-md-2 border bg-warning">
                                        <h3>10 + Year</h3>
                                    </div>
                                    <div className="col-12 col-md-10">
                                        <h5>Of Successful Work & <br />
                                         Experience Of Training</h5>
                                         
                                    </div>
                                    <button type="button" class="btn btn-outline-info w-25 mt-4">Learn More</button>
                                    
                                 </div>
                        </div>

                        <div className="col-12  col-md-6">
                                <img src={img1} alt="" className="w-75" />
                        </div>

                        </div>
                    </div>

                </section>
            </section>
        </section>
        </>
    );

}
export default Coache;